import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { useLanguage } from "../../../../context/LanguageContext";
import "./Process.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`Process field "${key}" is missing from the API response.`);
  }
  return value;
};

const requireMediaUrl = (section, groupKey) => {
  const item = section.media?.groups?.[groupKey]?.[0] || null;
  if (!item?.url) {
    throw new Error(`Process media group "${groupKey}" is missing from the API response.`);
  }
  return resolveMediaUrl(item.url);
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    bannerText: requireField(f, "bannerText"),
    bannerIcon: requireMediaUrl(section, "banner"),
    steps: [
      {
        label: requireField(f, "step1Label"),
        text: requireField(f, "step1Text"),
        icon: requireMediaUrl(section, "step-1"),
      },
      {
        label: requireField(f, "step2Label"),
        text: requireField(f, "step2Text"),
        icon: requireMediaUrl(section, "step-2"),
      },
      {
        label: requireField(f, "step3Label"),
        text: requireField(f, "step3Text"),
        icon: requireMediaUrl(section, "step-3"),
      },
    ],
  };
};

const Process = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection("home", "process", buildModel);

  if (isLoading) {
    return (
      <section className="process" id="process" dir={meta.dir}>
        <div className="process__container">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading process…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="process" id="process" dir={meta.dir}>
        <div className="process__container">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Process unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="process" id="process" dir={meta.dir}>
      <div className="process__container">
        <div className="process__header">
          <span className="process__badge">{model.badge}</span>
          <h2 className="process__title">{model.title}</h2>
        </div>

        <div className="process__cards">
          {model.steps.map((item) => (
            <article key={item.label} className="process__card">
              <div className="process__card-icon">
                <img src={item.icon} alt="" aria-hidden="true" />
              </div>
              <div>
                <h3 className="process__card-step">{item.label}</h3>
                <p className="process__card-text">{item.text}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="process__banner">
          <img
            src={model.bannerIcon}
            alt=""
            className="process__banner-icon"
            aria-hidden="true"
          />
          <p className="process__banner-text">{model.bannerText}</p>
        </div>
      </div>
    </section>
  );
};

export default Process;
